import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import settings from "./locales/settings.json";

const loadResources = async () => {
    const resources = {};

    for (const language of settings.languages) {
        const module = await import(`./locales/${language}.json`, { assert: { type: "json" } });
        resources[language] = { translation: module.default };
    }

    return resources;
};

const initI18n = async () => {
    const resources = await loadResources();

    await i18n
        .use(initReactI18next)
        .init({
            resources,
            fallbackLng: settings.language,
            interpolation: {
                escapeValue: false,
            },
            debug: true,
        });
};

await initI18n();

export default i18n;